export default "__VITE_ASSET__BtkQFc4V__"